import { useDispatch } from 'react-redux'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { refreshCounter } from 'store/actions/refresh'
import { FileAttachments } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { Spinner } from 'ui'
import Api from 'services/Api'

import { t } from 'translations'
import { UPLOAD_ATTACHMENTS_TYPES } from 'common'
import { UserFile } from 'Api'

const UserAttachmentsModal = ({ userId }) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const {
    data: userFiles,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: ['usersFiles', { userId }],
    queryFn: async (): Promise<UserFile[]> => {
      const { result, success } = await Api.get(`/users/files/${userId}`)
      if (!success) return []
      return result
    }
  })

  const { mutate } = useMutation({
    mutationFn: async (files: UserFile[]) => {
      await Api.patch(`/users/files/${userId}`, { files })
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['usersFiles', { userId }])
      dispatch(refreshCounter('users'))
    }
  })

  if (isLoading) return <Spinner />
  if (!isSuccess) return <div>{t('components.attachments.ERROR')}</div>

  return (
    <BaseModal>
      <FileAttachments
        onAfterDrop={file => {
          if (!file) return
          const newState = [...userFiles, { name: file.name, key: file.key, type: file.type }]
          mutate(newState)
        }}
        onAfterRemove={file => {
          if (!file) return
          const newState = [...userFiles.filter(myfile => myfile.key !== file.key)]
          mutate(newState)
        }}
        files={userFiles}
        attachmentType={UPLOAD_ATTACHMENTS_TYPES.USERS}
      />
    </BaseModal>
  )
}

export default UserAttachmentsModal
